import { sectionConfig as config } from "~/config/_pages/home/features";
import FeaturesUI from "~/components/ui/_home/features";

export default function FeaturesSection() {
  return (
    <FeaturesUI>
      <FeaturesUI.Row count="two">
        {config.items.slice(0, 2).map((item, index) => (
          <FeaturesUI.Item key={index} index={index}>
            <FeaturesUI.ItemTitle>{item.title}</FeaturesUI.ItemTitle>
            <FeaturesUI.ItemBody link={item.link}>
              {item.caption}
            </FeaturesUI.ItemBody>
          </FeaturesUI.Item>
        ))}
      </FeaturesUI.Row>
      <FeaturesUI.Row count="three">
        {config.items.slice(2, 5).map((item, index) => (
          <FeaturesUI.Item key={index} index={index}>
            <FeaturesUI.ItemTitle>{item.title}</FeaturesUI.ItemTitle>
            <FeaturesUI.ItemBody link={item.link}>
              {item.caption}
            </FeaturesUI.ItemBody>
          </FeaturesUI.Item>
        ))}
      </FeaturesUI.Row>
    </FeaturesUI>
  );
}
